/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-09 12:01:11
 */
import { service } from '@/utils/request'

export default {
  //分页获取调度任务列表
  getSchedulerTaskList: (data) => {
    return service({
      url: '/cloud/job/task/page',
      method: 'post',
      data: data
    })
  },
  //更改调度任务状态
  changeSchedulerTaskStatus: (path) => {
    return service({
      url: '/cloud/job/task/set' + path,
      method: 'get',
    })
  },
  //立即执行
  immediateActive: (path) => {
    return service({
      url: '/cloud/job/task/active' + path,
      method: 'get',
    })
  },
  //获取服务列表
  getAppListApi: () => {
    return service({
      url: '/cloud/job/app/simple/list',
      method: 'get',
    })
  },
  //获取详情
  getDedatilApi: (path) => {
    return service({
        url: '/cloud/job/task/find' + path,
        method: 'get',
      })
  },
  //增加调度任务
  addTask: (data) => {
    return service({
      url: '/cloud/job/task/add',
      method: 'post',
      data: data
    })
  },
   //修改调度任务
   editTask: (data) => {
    return service({
      url: '/cloud/job/task/modify',
      method: 'post',
      data: data
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/systemManage/schedulerTask.js